import styled from 'styled-components'

export const RescheduleBookingCalendarUi = styled.div`
  width: 100%;
  min-height: 90vh;
  display: flex;
  justify-content: center;
  align-items: center;
`
